// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Стили для разметки Markdown */
.markdown-content {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  line-height: 1.7;
  font-size: 16px;
}

/* Адаптивные отступы для текста */
@media (max-width: 600px) {
  .markdown-content {
    font-size: 15px;
    line-height: 1.6;
  }
}

/* Улучшение внешнего вида таблиц */
.markdown-content table {
  border-collapse: collapse;
  width: 100%;
  margin: 1.5rem 0;
  overflow-x: auto;
  display: block;
}

.markdown-content table th {
  background-color: rgba(0, 0, 0, 0.05);
  font-weight: 600;
  text-align: left;
}

.markdown-content table th,
.markdown-content table td {
  padding: 0.75rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.markdown-content table tr:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.025);
}

/* Для темного режима */
.markdown-content[data-color-mode="dark"] table th {
  background-color: rgba(255, 255, 255, 0.1);
}

.markdown-content[data-color-mode="dark"] table th,
.markdown-content[data-color-mode="dark"] table td {
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.markdown-content[data-color-mode="dark"] table tr:nth-child(even) {
  background-color: rgba(255, 255, 255, 0.03);
}

/* Списки */
.markdown-content ul,
.markdown-content ol {
  padding-left: 1.5rem;
  margin-bottom: 1.5rem;
}

.markdown-content li {
  margin-bottom: 0.5rem;
}

.markdown-content li > ul,
.markdown-content li > ol {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

/* Горизонтальная линия */
.markdown-content hr {
  border: none;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  margin: 1.5rem 0;
}

.markdown-content[data-color-mode="dark"] hr {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Изображения */
.markdown-content img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 1rem 0;
  display: block;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.markdown-content[data-color-mode="dark"] img {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

/* Выделение текста */
.markdown-content mark {
  background-color: rgba(255, 250, 118, 0.4);
  padding: 0.1em 0.2em;
  border-radius: 4px;
}

.markdown-content[data-color-mode="dark"] mark {
  background-color: rgba(255, 250, 118, 0.2);
}

/* Настройка блока кода */
.markdown-content pre {
  font-family: 'Fira Code', 'Menlo', 'Monaco', 'Courier New', monospace;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-x: auto;
}

/* Выделение строк в коде */
.markdown-content pre code .token.comment {
  color: #6a737d;
}

.markdown-content[data-color-mode="dark"] pre code .token.comment {
  color: #8c96a3;
}

/* Стиль для перехода между темами */
.markdown-content {
  transition: all 0.3s ease;
} 

.wmde-markdown {
    background-color: transparent !important;
  }

.markdown-content h1,
.markdown-content h2,
.markdown-content h3,
.markdown-content h4,
.markdown-content h5,
.markdown-content h6 {
  position: relative;
  scroll-margin-top: 80px;
}

.markdown-content h1 a[id],
.markdown-content h2 a[id],
.markdown-content h3 a[id],
.markdown-content h4 a[id],
.markdown-content h5 a[id],
.markdown-content h6 a[id] {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/markdown-styles.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,yFAAyF;EACzF,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,uBAAuB;AACvB;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,WAAW;AACX;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,qBAAqB;AACrB;EACE,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,yBAAyB;AACzB;EACE,qEAAqE;EACrE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;AAC3B;;AAEA;IACI,wCAAwC;EAC1C;;AAEF;;;;;;EAME,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;;;;;EAME,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,oBAAoB;AACtB","sourcesContent":["/* Стили для разметки Markdown */\r\n.markdown-content {\r\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\r\n  line-height: 1.7;\r\n  font-size: 16px;\r\n}\r\n\r\n/* Адаптивные отступы для текста */\r\n@media (max-width: 600px) {\r\n  .markdown-content {\r\n    font-size: 15px;\r\n    line-height: 1.6;\r\n  }\r\n}\r\n\r\n/* Улучшение внешнего вида таблиц */\r\n.markdown-content table {\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n  margin: 1.5rem 0;\r\n  overflow-x: auto;\r\n  display: block;\r\n}\r\n\r\n.markdown-content table th {\r\n  background-color: rgba(0, 0, 0, 0.05);\r\n  font-weight: 600;\r\n  text-align: left;\r\n}\r\n\r\n.markdown-content table th,\r\n.markdown-content table td {\r\n  padding: 0.75rem;\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.markdown-content table tr:nth-child(even) {\r\n  background-color: rgba(0, 0, 0, 0.025);\r\n}\r\n\r\n/* Для темного режима */\r\n.markdown-content[data-color-mode=\"dark\"] table th {\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.markdown-content[data-color-mode=\"dark\"] table th,\r\n.markdown-content[data-color-mode=\"dark\"] table td {\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.markdown-content[data-color-mode=\"dark\"] table tr:nth-child(even) {\r\n  background-color: rgba(255, 255, 255, 0.03);\r\n}\r\n\r\n/* Списки */\r\n.markdown-content ul,\r\n.markdown-content ol {\r\n  padding-left: 1.5rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.markdown-content li {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.markdown-content li > ul,\r\n.markdown-content li > ol {\r\n  margin-top: 0.5rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n/* Горизонтальная линия */\r\n.markdown-content hr {\r\n  border: none;\r\n  height: 1px;\r\n  background-color: rgba(0, 0, 0, 0.1);\r\n  margin: 1.5rem 0;\r\n}\r\n\r\n.markdown-content[data-color-mode=\"dark\"] hr {\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n/* Изображения */\r\n.markdown-content img {\r\n  max-width: 100%;\r\n  height: auto;\r\n  border-radius: 8px;\r\n  margin: 1rem 0;\r\n  display: block;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.markdown-content[data-color-mode=\"dark\"] img {\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Выделение текста */\r\n.markdown-content mark {\r\n  background-color: rgba(255, 250, 118, 0.4);\r\n  padding: 0.1em 0.2em;\r\n  border-radius: 4px;\r\n}\r\n\r\n.markdown-content[data-color-mode=\"dark\"] mark {\r\n  background-color: rgba(255, 250, 118, 0.2);\r\n}\r\n\r\n/* Настройка блока кода */\r\n.markdown-content pre {\r\n  font-family: 'Fira Code', 'Menlo', 'Monaco', 'Courier New', monospace;\r\n  line-height: 1.5;\r\n  white-space: pre-wrap;\r\n  word-break: break-word;\r\n  overflow-x: auto;\r\n}\r\n\r\n/* Выделение строк в коде */\r\n.markdown-content pre code .token.comment {\r\n  color: #6a737d;\r\n}\r\n\r\n.markdown-content[data-color-mode=\"dark\"] pre code .token.comment {\r\n  color: #8c96a3;\r\n}\r\n\r\n/* Стиль для перехода между темами */\r\n.markdown-content {\r\n  transition: all 0.3s ease;\r\n} \r\n\r\n.wmde-markdown {\r\n    background-color: transparent !important;\r\n  }\r\n\r\n.markdown-content h1,\r\n.markdown-content h2,\r\n.markdown-content h3,\r\n.markdown-content h4,\r\n.markdown-content h5,\r\n.markdown-content h6 {\r\n  position: relative;\r\n  scroll-margin-top: 80px;\r\n}\r\n\r\n.markdown-content h1 a[id],\r\n.markdown-content h2 a[id],\r\n.markdown-content h3 a[id],\r\n.markdown-content h4 a[id],\r\n.markdown-content h5 a[id],\r\n.markdown-content h6 a[id] {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  pointer-events: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
